import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '@/components/atoms/Alert';
import { Button } from '@/components/atoms/Buttons';

import styles from './CreateApiUserModal.module.scss';

interface CopyToClipboardProps {
    title: string;
    textToCopy: string;
}

export function CopyToClipboardComponent(props: CopyToClipboardProps) {
    const { title, textToCopy } = props;
    const { t } = useTranslation();

    const [copyStatus, setCopyStatus] = useState<'idle' | 'copied' | 'error'>('idle');

    const copyToClipboardHandler = (text: string) => {
        navigator.clipboard.writeText(text).then(
            () => {
                setCopyStatus('copied');
                setTimeout(() => setCopyStatus('idle'), 3000);
            },
            () => {
                setCopyStatus('error');
                setTimeout(() => setCopyStatus('idle'), 3000);
            }
        );
    };

    return (
        <>
            <div className={styles.copyToClipboardTitle}>{title}</div>
            <div className={styles.copyToClipboardContainer}>
                <div className={styles.copyToClipboardValue}>{textToCopy}</div>
                <Button
                    variant="secondary"
                    size="small"
                    onClick={() => copyToClipboardHandler(textToCopy)}
                    type="button"
                    title={t('internal.createApiUser.copyToClipboard')}>
                    {copyStatus === 'copied' ? '✓' : t('common.actions.copy')}
                </Button>
            </div>
            {copyStatus === 'error' && (
                <Alert tone="danger" size="small" className={styles.copyErrorMessage}>
                    {t('internal.createApiUser.copyFailed')}
                </Alert>
            )}
        </>
    );
}
